import React from 'react';
import { Props } from './types';
import { Select } from 'antd';
import { SmileOutlined, FrownOutlined } from '@ant-design/icons';
import Justification from '../../Modal/Justification';
import { IModification } from '../../Modal/Justification/types';
import { SKW_PREFIX } from '../../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import api from '../../../../service/api';
import { openNotification } from '../../Utils';
import { loadRequest } from '../../../../store/ducks/ocorrencia/actions';
import { loadRequest as loadProgressBarSLA } from '../../../../store/ducks/progressBarSLA/actions';

const SelectStatus: React.FC<Props> = ({ protocolo, status, setShowDepartamento }) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState<boolean>(false);
  const [modification, setModification] = React.useState<IModification>();
  const token = useSelector((state: ApplicationState) => state.auth.token);

  const handleChange = (value: string): void => {
    if (value === 'ARI') {
      if (setShowDepartamento) setShowDepartamento(true);
      return;
    } else if (value === 'EA') {
      api
        .post(`call?serviceName=${SKW_PREFIX}atualizaOcorrencia&token=${token}`, {
          protocolo: protocolo,
          status: value,
        })

        .then(() => {
          dispatch(loadRequest(protocolo));
          dispatch(loadProgressBarSLA(protocolo));
          openNotification('Ok!', <SmileOutlined />, 'Alteração efetuada com sucesso!');
        })
        .catch(() => {
          openNotification('Ops!', <FrownOutlined />, 'Não foi possível efetuar essa alteração!');
        });
    } else {
      if (setShowDepartamento) setShowDepartamento(false);
      setModification({
        status: value,
      });
      setOpen(true);
    }
  };

  return (
    <>
      <Justification
        open={open}
        setOpen={setOpen}
        modification={modification}
        setShowDepartamento={setShowDepartamento}
      />
      <Select
        data-cy="selectStatus"
        defaultValue={status}
        onChange={handleChange}
        style={{ width: '100%' }}
      >
        <Option value="AA">Aguardando atendimento</Option>
        <Option value="EA">Em atendimento</Option>
        <Option value="ARI">Aguardando retorno interno</Option>
        <Option value="ARC">Aguardando retorno do cliente</Option>
        <Option value="AC">Atendimento finalizado</Option>
      </Select>
    </>
  );
};

export default SelectStatus;
